<template>
  <div class="homeBody">
    <div class="headerBody">
      <div class="logoBox">区域海洋-海浪-大气全耦合预报</div>
      <div class="changePageBox">
        <div class="changePageBoxItem active">数值预报</div>
        <div class="changePageBoxItem">站点预报</div>
        <div class="changePageBoxItem">图形产品</div>
        <div class="changePageBoxItem">返回首页</div>
      </div>
    </div>
    <!-- <div ></div> -->
    <router-view class="mainView"></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
.homeBody {
  height: 100vh;
  width: 100vw;
  /* background-color: aqua; */
}
.headerBody {
  height: 60px;
  width: 100%;
  background-color: #102d50;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}
.logoBox {
  height: 60px;
  width: 250px;
  /* background-color: aqua; */
  color: white;
  line-height: 60px;
}
.changePageBox {
  /* width: 500px; */
  height: 60px;
  display: flex;
  /* background-color: antiquewhite; */
}
.changePageBoxItem {
  line-height: 50px;
  margin-right: 15px;
  color: white;
  padding: 5px;
  /* width: ; */
}
.active {
  background-color: #3f9dfe;
}
.mainView {
  height: calc(100vh - 60px);
  width: 100vw;
  /* background-color: #3f9dfe; */
}
</style>